export const ServiceCTA = () => {
  return (
    <section className="py-24 text-center bg-gradient-to-r from-blue-500 to-purple-600 text-white">
      <h2 className="text-4xl font-bold mb-6">
        Let’s Build Your Next Big Idea 🚀
      </h2>

      <p className="mb-8 max-w-2xl mx-auto">
        Partner with us to create scalable, innovative, and high-performing digital solutions.
      </p>

      <div className="flex justify-center gap-4">
        <button className="px-6 py-3 bg-white text-black rounded-lg">
          Get Free Consultation
        </button>

        <button className="px-6 py-3 border border-white rounded-lg">
          Contact Us
        </button>
      </div>
    </section>
  );
};